<div class="pr-tainer accessories-page">
    <div class="container">
        <div class="header-row">
            <div>
                <h3 class="page-title">Add Accessories</h3>
                <p class="section-desc">Accessories are a way to manage and assign additional equipment items.</p>
            </div>
            <button class="fab" *ngIf="showAddAccessoryFab" (click)="addAccessory()"><span>+</span></button>
        </div>
    </div>

    <!-- Add/Edit Accessory Modal -->
    <div class="modal-backdrop" *ngIf="showAddAccessoryModal || showEditAccessoryModal">
        <div class="modal add-accessory-modal">
            <div class="modal-header">
                <span class="modal-title">{{ showEditAccessoryModal ? 'Edit Accessory' : 'Add Accessory' }}</span>
                <button class="modal-close"
                    (click)="showEditAccessoryModal ? closeEditAccessoryModal() : closeAddAccessoryModal()">&times;</button>
            </div>

            <div class="modal-body">
                <form (ngSubmit)="showEditAccessoryModal ? saveAccessoryEdit() : saveNewAccessory()">

                    <!-- Accessory Name -->
                    <div class="modal-form-row">
                        <label>*Accessory Name</label>
                        <input type="text" maxlength="100" [(ngModel)]="accessoryToEdit.accessoryName"
                            name="accessoryName" required />
                    </div>

                    <!-- Accessory Type -->
                    <div class="modal-form-row">
                        <label>*Accessory Type</label>
                        <select [(ngModel)]="accessoryToEdit.accessoryType" name="accessoryType" required
                            (change)="accessoryToEdit.model = ''; accessoryToEdit.detail = ''">
                            <option *ngFor="let type of accessoryTypes" [value]="type">
                                {{ type }}
                            </option>
                        </select>
                    </div>

                    <!-- Model -->
                    <div class="modal-form-row">
                        <label>Model</label>
                        <select [(ngModel)]="accessoryToEdit.model" name="model"
                            [disabled]="!accessoryToEdit.accessoryType">
                            <option *ngFor="let model of getModelsForType(accessoryToEdit.accessoryType)"
                                [value]="model">
                                {{ model }}
                            </option>
                        </select>
                    </div>

                    <!-- Detail -->
                    <div class="modal-form-row">
                        <label>Detail</label>
                        <select [(ngModel)]="accessoryToEdit.detail" name="detail"
                            [disabled]="!accessoryToEdit.accessoryType">
                            <option *ngFor="let detail of getDetailsForType(accessoryToEdit.accessoryType)"
                                [value]="detail.value">
                                {{ detail.name }}
                            </option>
                        </select>
                    </div>
                </form>
            </div>

            <div class="modal-footer">
                <button class="modal-cancel"
                    (click)="showEditAccessoryModal ? closeEditAccessoryModal() : closeAddAccessoryModal()">Cancel</button>
                <button class="modal-save"
                    (click)="showEditAccessoryModal ? saveAccessoryEdit() : saveNewAccessory()">Save</button>
            </div>
        </div>
    </div>
</div>